module.exports = __webpack_public_path__ + "static/media/7.Wet Grinder Big.a3bc924e.jpeg";